// @mui
import { styled } from '@mui/material/styles';
import { Typography, Button, Container, Stack, Card, Grid, Switch } from '@mui/material';
// components
import Page from '../components/Page';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(() => ({
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column'
}));

// ----------------------------------------------------------------------

// button

const MyButton = ({ children }) => (
  <button type="button" style={{
    backgroundColor: "blue",
    color: "white",
    fontSize: "0.9em",
    paddingInline: 16,
    border: "none",
    cursor: "pointer"
  }}>{children}</button>
)

const Input = () => (
  <input style={{
    width: "100%",
    height: 42,
    borderRadius: 4,
    paddingInline: 8,
    border: "1px solid #bebebe"
  }} type="password"/>
)

const label = { inputProps: { 'aria-label': 'Switch demo' } };

export default function PaymentGateway() {
  return (
    <Page title="Profile">
      <Container>
        <ContentStyle>
        <Stack sx={{width:"100%", mb: 4}} direction="row" justifyContent="space-between">
          <Typography variant="h4" paragraph>
            Payment Options
          </Typography>
          <Button variant="contained">Save</Button>
          </Stack>
          
            <Grid container spacing={2}>
            <Grid item xs>
            <Card sx={{p:2}}>
            <Stack direction="row" justifyContent="space-between">
            <h3>RazorPay</h3>
            <MyButton>Edit</MyButton>
            </Stack>
              <div>
              Enable
      <Switch {...label} defaultChecked />
        </div>
        api_secret_key
        <Input/>
        api_publishable_key
        <Input/>
                </Card>
              </Grid>
              <Grid item xs>
              <Card sx={{p:2, height: "100%"}}>
              <h3>Stripe</h3>
              <div>
              Enable
      <Switch {...label} defaultChecked />
        </div>
                </Card>
              </Grid>
            </Grid>
        </ContentStyle>
      </Container>
    </Page>
  );
}
